import type { ScmProviderId } from '@/types/scm-provider';
import { scmPost } from './scmClient';

export interface ReleasePipeline {
  id: number;
  name: string;
  path: string;
  isDeleted: boolean;
}

interface ReleasePipelinesResponse {
  data: {
    pipelines: ReleasePipeline[];
  };
}

interface RequestBody {
  provider: ScmProviderId;
  body: {
    organization: string;
    project: string;
    orgUrl: string;
  };
  requesterToken: { patToken: string };
}

export const getReleasePipelines = ({
  provider,
  body,
  requesterToken,
}: RequestBody): Promise<ReleasePipelinesResponse> => {
  return scmPost(provider, '/api/scm/environments', requesterToken.patToken, {
    organization: body.organization,
    project: body.project,
    repository: '',
  });
};
